import { getNinjaConfig } from '@/config/ninja.ts';
import { getRegionConfig } from '@/config/region.ts';
import { AVAILABLE_TRACKERS, Tracker } from '@/generated/types.generated.ts';
import { getLogger } from '@/logger';
import { ConfigDetails } from '@/types/configs.ts';

export const configMap = new Map<Tracker, ConfigDetails>();
const logger = getLogger('configs/getTrackerConfig');

export function getTrackerConfig(tracker: Tracker) {
  try {
    const trackerAbbr = AVAILABLE_TRACKERS[tracker];

    if (!trackerAbbr) {
      logger.warn(`getTrackerConfig returns no available tracker for ${tracker}`);
      return {};
    }

    if (!configMap.has(tracker)) {
      const regionConfig = getRegionConfig();
      const baseConfig = regionConfig!.config[trackerAbbr] ?? {}; // this is always available
      const siteConfig = regionConfig!.custom?.[getNinjaConfig().siteUrl]?.config[trackerAbbr] ?? {};
      const ninjaConfig = getNinjaConfig().custom?.[trackerAbbr] ?? {};

      configMap.set(tracker, { ...baseConfig, ...siteConfig, ...ninjaConfig });
    }
  } catch (e) {
    logger.debug(`Error getting hydra config for ${tracker}`, e);
  }

  return configMap.get(tracker) ?? {};
}
